/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SearchFilterSection from "../../components/common/SearchFilterSection";
import Provider from "../../components/tables/Provider";
import { getApiCaller } from "../../libs/apiCaller";
import { getUniqueValues } from "../../libs/UnauthorisedPage";
import { setListProvider } from "../../redux/slices/providerSlice";

const ProviderList = () => {
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [filteredProviders, setFilteredProviders] = useState([]);
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  const fetchProviders = async () => {
    try {
      const response = await getApiCaller("providers_list");
      setProviders(response.data.response_data);
      setFilteredProviders(response.data.response_data);
      setStates(
        getUniqueValues(response?.data?.response_data, "billing_state")
      );
      dispatch(setListProvider(response.data.response_data));
    } catch (error) {
      toast.error("Failed to fetch providers. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchProviders();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [searchTerm, selectedState, selectedCity]);

  const applyFilters = () => {
    let filteredData = providers;

    if (searchTerm) {
      filteredData = filteredData.filter((consumer) => {
        const fullName = `${consumer?.first_name || ""} ${
          consumer.last_name || ""
        }`?.toLowerCase();
        return fullName?.includes(searchTerm?.toLowerCase());
      });
    }

    if (selectedState) {
      filteredData = filteredData.filter(
        (consumer) => consumer.billing_state === selectedState
      );
      setCities(getUniqueValues(filteredData, "billing_city"));
    } else {
      setCities(getUniqueValues(providers, "billing_city"));
    }

    if (selectedCity) {
      filteredData = filteredData.filter(
        (consumer) => consumer.billing_city === selectedCity
      );
    }

    setFilteredProviders(filteredData);
  };

  const clearFilters = () => {
    setSearchTerm("");
    setSelectedState("");
    setSelectedCity("");
    setFilteredProviders(providers);
    setCities(getUniqueValues(providers, "billing_city"));
  };

  return (
    <>
      <div className="px-4 md:px-10">
        <div className="flex justify-between border border-1 px-4 py-3 rounded-t-2xl mt-4 bg-white">
          <p className="text-[#284184] font-bold text-xl">Approved Providers</p>
          <Link
            to={"/PendingRegistration"}
            className="text-[#284184] font-bold underline"
          >
            Pending Registration
          </Link>
        </div>
        <div className="border border-t-0 px-4 py-3 rounded-b-2xl text-xl bg-white">
          <SearchFilterSection
            searchTextPlaceholder={"Search Provider"}
            searchTerm={searchTerm}
            selectedCity={selectedCity}
            selectedState={selectedState}
            cities={cities}
            states={states}
            clearFilters={clearFilters}
            setSearchTerm={setSearchTerm}
            setSelectedCity={setSelectedCity}
            setSelectedState={setSelectedState}
          />

          <Provider
            isLoading={loading}
            providers={filteredProviders}
            setProviders={setProviders}
            fetchProviders={fetchProviders}
          />
        </div>
      </div>
    </>
  );
};

export default ProviderList;
